import Marionette from "backbone.marionette";
import $ from "jquery";

export default Marionette.View.extend({
    template: false,
    ui: {
        intro: ".js-intro",
        outro: ".js-outro",
        continue: ".js-continue",
        stop: ".js-stop",
    },
    events: {
        "click .modal-cover": "onHide",
        "click .wsicon-close": "onHide",
        "click @ui.continue": "onContinue",
        "click @ui.stop": "onStop",
    },
    render() {
        this.ui.intro.show();
        this.$el.fadeIn(350);
    },
    onStop(event) {
        event.preventDefault();
        this.ui.stop.loading(true);

        // Save their address info if they decide to stop applying
        $.ajax({
            type: "PATCH",
            url: "/api/hire/v1/profile/",
            dataType: "json",
            contentType: "application/json",
            data: JSON.stringify({
                ...this.model.toJSON(),
                location_screen: true,
            }),
        }).done(() => {
            setTimeout(() => {
                if (this.options.isProfile) {
                    window.location.reload();
                } else {
                    window.location.href = "/jobs";
                }
            }, 0);
        });
    },
    onContinue(event) {
        event.preventDefault();

        this.ui.intro.hide();
        this.ui.outro.fadeIn(350);

        setTimeout(() => {
            this.hide();
            this.trigger("complete");
        }, 500);
    },
    onHide(event) {
        event.preventDefault();

        this.hide();
    },
    hide() {
        this.$el.fadeOut(350);
    },
});
